import React from 'react';
import { Route } from 'react-router-dom';
import { AddonsSettingPage } from './Routes';

export const routes = [<Route key={0} path="/addon-settings" component={AddonsSettingPage} />];

export const navigation = [{ name: 'addon', link: '/addon-settings', match: '/addon-settings', icon: 'Addons' }];
